import { Network } from 'config/types'
import { useMemo } from 'react'
import { useAllTokens, useListNetworks } from 'state/app/hooks'

export const useSwapableTokens = () => {
  const swapableTokens = useAllTokens((_, __, ___, info) => !info.disabledSwap)
  return useMemo(() => ({ swapableTokens }), [swapableTokens])
}

export const useSwapableNetworks = (): Record<string, Network[]> => {
  const { swapableTokens } = useSwapableTokens()
  const networkList = useListNetworks()

  const swapableNetworks: Record<string, Network[]> = useMemo(() => {
    const networksCurrencySameCode: Record<string, Network[]> = {}

    swapableTokens.forEach((token) => {
      if (!networksCurrencySameCode[token.code]) {
        networksCurrencySameCode[token.code] = []
      }

      const networkInfo = networkList.find((network) => network.chainId === token.network)
      if (networkInfo && !networksCurrencySameCode[token.code].some((n) => n.chainId === networkInfo.chainId)) {
        networksCurrencySameCode[token.code].push(networkInfo)
      }
    })
    return networksCurrencySameCode
  }, [swapableTokens, networkList])

  return useMemo(() => swapableNetworks, [swapableNetworks])
}
